import {
  querySites as publicQuerySites,
  typedQuerySites as publicTypedQuerySites,
  countSites as publicCountSites,
} from './site-list-v2-site-sites.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  SiteQuery,
  SitesQueryBuilder,
  typedQuerySites as universalTypedQuerySites,
} from './site-list-v2-site-sites.universal.js';
import { onSiteCreated as publicOnSiteCreated } from './site-list-v2-site-sites.public.js';
import { onSiteDeleted as publicOnSiteDeleted } from './site-list-v2-site-sites.public.js';
import { onSiteUpdated as publicOnSiteUpdated } from './site-list-v2-site-sites.public.js';

function customQuerySites(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQuerySites(httpClient)(),
    typedQueryFunction: (query: SiteQuery) =>
      publicTypedQuerySites(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): SitesQueryBuilder;
  function overloadedQuery(
    query: SiteQuery
  ): ReturnType<typeof universalTypedQuerySites>;
  function overloadedQuery(query?: SiteQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const countSites: MaybeContext<
  BuildRESTFunction<typeof publicCountSites> & typeof publicCountSites
> = /*#__PURE__*/ createRESTModule(publicCountSites);
export const querySites: MaybeContext<
  BuildRESTFunction<typeof customQuerySites> & typeof customQuerySites
> = /*#__PURE__*/ createRESTModule(customQuerySites);
/**
 * Triggered when a site is created.
 */
export const onSiteCreated: BuildEventDefinition<typeof publicOnSiteCreated> &
  typeof publicOnSiteCreated = createEventModule(publicOnSiteCreated);
/**
 * Triggered when a site is deleted.
 */
export const onSiteDeleted: BuildEventDefinition<typeof publicOnSiteDeleted> &
  typeof publicOnSiteDeleted = createEventModule(publicOnSiteDeleted);
/**
 * Triggered when a site is updated.
 */
export const onSiteUpdated: BuildEventDefinition<typeof publicOnSiteUpdated> &
  typeof publicOnSiteUpdated = createEventModule(publicOnSiteUpdated);

export {
  EditorType,
  Namespace,
  SortOrder,
  WebhookIdentityType,
} from './site-list-v2-site-sites.universal.js';
export {
  Site,
  QuerySitesRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  CursorPaging,
  QuerySitesResponse,
  PagingMetadataV2,
  Cursors,
  CountSitesRequest,
  CountSitesResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  SiteCreatedEnvelope,
  SiteDeletedEnvelope,
  SiteUpdatedEnvelope,
  SitesQueryResult,
  SitesQueryBuilder,
  SiteQuerySpec,
  CountSitesOptions,
} from './site-list-v2-site-sites.universal.js';
export { utils } from './site-list-v2-site-sites.universal.js';
export {
  EditorTypeWithLiterals,
  NamespaceWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  QuerySitesApplicationErrors,
  CountSitesApplicationErrors,
  CommonQueryWithEntityContext,
  SiteQuery,
} from './site-list-v2-site-sites.universal.js';
